module.exports = "<div class=\"sc-dashboard-view\"><div ng-if=\"$ctrl.filterData.loading\"><i class=\"icon-loading animate-spin\"></i></div><sc-card ng-if=\"!$ctrl.filterData.loading && !$ctrl.filter.isCardAccount\" card=\"$ctrl.filterData.filterData\"></sc-card><sc-card-account ng-if=\"!$ctrl.filterData.loading && $ctrl.filter.isCardAccount\" card=\"$ctrl.filterData.filterData\"></sc-card-account><div class=\"row-fluid\"><sc-dashboard-node ng-repeat=\"filter in $ctrl.filter.children\" filter=\"filter\" class=\"span{{filter.cardWidth}}\"></sc-dashboard-node></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/dashboard.component.html
// module id = 401
// module chunks = 0